module.exports = __webpack_public_path__ + "static/media/touch-direction.0e2d72fa.svg";